import deepmerge from 'deepmerge';
import store from "@/store";

import oneUtils from "../../gcdm-one-library/gcdm-one-utils/src/bootstrap";

const checkBackwardCompatibility = (queryParameters)=>{
  const isLocaleBackwardCompatibilityNeeded = queryParameters.locale &&
      (!queryParameters.language || !queryParameters.country);
  if (isLocaleBackwardCompatibilityNeeded) {
    const locale = queryParameters.locale;
    const isLocaleValid = locale.length === 5 && locale.includes("-");
    if (isLocaleValid) {
      const localeCountry = locale.split("-")[0];
      const localeLanguage = locale.split("-")[1];
      if (!queryParameters.country) queryParameters.country = localeCountry;
      if (!queryParameters.language) queryParameters.language = localeLanguage;
    }
  }
  return queryParameters;
}
const evaluateBrand = (client, queryParameters, configuration)=>{
  const qsBrand = client.allowed.brands.includes(queryParameters.brand)
  ? queryParameters.brand
  : undefined;
  const defaultBrand = client.allowed.brands.includes(client.default.brand)
  ? client.default.brand
  : undefined;
  configuration.brand = qsBrand || defaultBrand || configuration.brand;
  return configuration;
}
const evaluateLanguage = (clientConfiguration, configuration, queryParameters, client, navigatorLanguage, baseConfiguration)=>{
  const isLanguageAllowed = (lang) => {
    return configUtils.isLanguageAllowed(clientConfiguration, configuration.brand, configuration.country, lang);
  };
  const qsLanguage = isLanguageAllowed(
    queryParameters.language
  )
    ? queryParameters.language
    : undefined;
  const clientdefaultLanguage = isLanguageAllowed(
    client.default.language
  )
    ? client.default.language
    : undefined;
  const browserLanguage = isLanguageAllowed(
    navigatorLanguage
  )
    ? navigatorLanguage
    : undefined;
  let fallbackLanguageByCountry;
  try {
    fallbackLanguageByCountry = baseConfiguration.config.country[configuration.country]._fallbackLanguage;
    fallbackLanguageByCountry = isLanguageAllowed(
      fallbackLanguageByCountry
    )
      ? fallbackLanguageByCountry
      : undefined;
  } catch (e) {}
  configuration.language =
    qsLanguage ||
    browserLanguage ||
    fallbackLanguageByCountry ||
    clientdefaultLanguage ||
    configuration.language;
    oneUtils.sessionUtils.updateHtmlLang(configuration.language);
  return configuration;
}
const evaluateCountry = async (client, queryParameters, configuration, navigatorCountry)=>{
  const qsCountry = client.allowed.countries.includes(
    queryParameters.country
    )
    ? queryParameters.country
    : undefined;
      
      
  // get country from localization
  let localizationCountryPromise;

  /* TODO READD: LOCALIZATION
  if(!qsCountry && !window.location.href.includes('logout')){
    const localizationCountry = store.getters.localizationCountry;
    if (!localizationCountry) {
      localizationCountryPromise = new Promise((resolve, reject)=>{
        navigator.geolocation.getCurrentPosition(
          (pos)=>{
            const currentLatitude=pos.coords.latitude;
            const currentLongitude=pos.coords.longitude;
            httpClient
              .geocode(pos.coords.latitude, pos.coords.longitude)
              .then((res: any) => {
                  store.dispatch("setupLocalizationCountry", res.data.countryCode);
                  resolve(res.data.countryCode);  
              })
              .catch((error) => {
                store.dispatch("setupLocalizationCountry", null);
                resolve(null);
              });
          },
          (err)=>{
            store.dispatch("setupLocalizationCountry", null);
            resolve(null);
          }
        );
      });
    }
  }
  */
  // wait
  let localizationCountry = await localizationCountryPromise;
  
  localizationCountry =  client.allowed.countries.includes(localizationCountry) ? localizationCountry : undefined;


  const defaultCountry = client.allowed.countries.includes(client.default.country)
  ? client.default.country
  : undefined;
  const browserCountry = client.allowed.countries.includes(navigatorCountry)
    ? navigatorCountry
    : undefined;
  configuration.country =
    qsCountry || localizationCountry || browserCountry || defaultCountry || configuration.country;

  return configuration;
}
const configUtils = {
  /**
   * evaluate configuration parameters based on ${clientConfiguration} and query string parameters provided.
   * @param baseConfiguration
   * @param clientConfiguration
   * @param queryParameters
   */
  async evaluateParams(baseConfiguration, clientConfiguration, queryParameters): Promise<any> {
    //BACKWARD COMPATIBILITY SUPPORT - START
    queryParameters = checkBackwardCompatibility(queryParameters);
    
    //BACKWARD COMPATIBILITY SUPPORT - END

    // const isClientConfig =
    //   clientConfiguration && clientConfiguration.client ? true : false;
    // console.debug(`utils - evaluateParams - IN: isClientConfig[${isClientConfig}] queryParameters: `, queryParameters);
    let configuration: any = {
      brand: oneUtils.properties.DEFAULT_FALLBACK_BRAND,
      language:oneUtils.properties.DEFAULT_FALLBACK_LANGUAGE,
      country: "",
    };


   
   

    //1. get locale info from browser settings
    const navigatorLocale = window.navigator.language;

    const splittedLocale = navigatorLocale.split('-');
    const navigatorLanguage = splittedLocale[0];
    const navigatorCountry = splittedLocale[1] ? splittedLocale[1].toUpperCase() : undefined;
    if (
      clientConfiguration &&
      clientConfiguration.client &&
      !oneUtils.utils.isObjEmpty(clientConfiguration.client)
    ){
      //2.a. check if provided parameters are compliance with che client configuration otherwise select default ones
      const client = clientConfiguration.client;
        
      // EVALUATE BRAND
      configuration = evaluateBrand(client, queryParameters, configuration);
     
      
      
      // EVALUATE COUNTRY
      configuration = await evaluateCountry(client, queryParameters, configuration, navigatorCountry);

      
      // EVALUATE LANGUAGE
      configuration = evaluateLanguage(clientConfiguration, configuration, queryParameters, client, navigatorLanguage, baseConfiguration);

      
    } else {
      //2.b. if no client configuration provided skip compliance check
      // EVALUATE BRAND
      configuration.brand = oneUtils.properties.SUPPORTED_BRANDS.includes(queryParameters.brand) ? queryParameters.brand : configuration.brand;
      // EVALUATE COUNTRY

      // get country from localization
      let localizationCountryPromise;
       /* TODO READD: LOCALIZATION
      if(!queryParameters.country && !window.location.href.includes('logout')){
        const localizationCountry = store.getters.localizationCountry;
        if (!localizationCountry) {
          localizationCountryPromise = new Promise((resolve, reject)=>{
            navigator.geolocation.getCurrentPosition(
              (pos)=>{
                const currentLatitude=pos.coords.latitude;
                const currentLongitude=pos.coords.longitude;
                httpClient
                  .geocode(pos.coords.latitude, pos.coords.longitude)
                  .then((res: any) => {
                    store.dispatch("setupLocalizationCountry", res.data.countryCode);
                    resolve(res.data.countryCode);
                  })
                  .catch((error) => {
                    store.dispatch("setupLocalizationCountry", null);
                    resolve(null);
                  });
              },
              (err)=>{
                store.dispatch("setupLocalizationCountry", null);
                resolve(null);
              }
            );
          });
        }
      }
      */
      // wait
      const localizationCountry = await localizationCountryPromise;

      configuration.country =
        queryParameters.country || localizationCountry || navigatorCountry || configuration.country;
      // EVALUATE LANGUAGE
      let fallbackLanguageByCountry;
      try {
        fallbackLanguageByCountry = baseConfiguration.config.country[configuration.country]._fallbackLanguage;
      } catch (e) {}
      configuration.language =
        queryParameters.language ||
        navigatorLanguage ||
        fallbackLanguageByCountry ||
        configuration.language;
        oneUtils.sessionUtils.updateHtmlLang(configuration.language);
    }

    // console.debug("utils - evaluateParams - OUT: ", configuration);
    return configuration;
  },
  fillObject: function(allowedLanguages, brandKey, countryKey, languages){
    if (!allowedLanguages['brand']) allowedLanguages['brand'] = {};
    if (!allowedLanguages['brand'][brandKey]) allowedLanguages['brand'][brandKey] = {};
    if (!allowedLanguages['brand'][brandKey]['country']) allowedLanguages['brand'][brandKey]['country'] = {};
    if (!allowedLanguages['brand'][brandKey]['country'][countryKey]) allowedLanguages['brand'][brandKey]['country'][countryKey] = {};
    allowedLanguages['brand'][brandKey]['country'][countryKey] = languages;
    return allowedLanguages;
  },
  createAllowedLanguagesDictionary: function(brand, config, allowedLanguages){
    try {
      if (brand) {
        Object.keys(config.brand).forEach((brandKey) => {
          const brandConfig = config.brand[brandKey];
          Object.keys(brandConfig.country).forEach((countryKey) => {
            const countryConfig = brandConfig.country[countryKey];
            const languages = Object.keys(countryConfig.language);
            
            // 1.a. fill object
            allowedLanguages = this.fillObject(allowedLanguages, brandKey, countryKey, languages);
           
          });
        });
      }
    } catch (e) {
    }
  },

  isLanguageAllowed: function(clientConfiguration: any, brand: string, country: string, lang: string) {
    if (!lang) return false;
    const config = clientConfiguration.config;
    // 1. create allowed languages dictionary
    let allowedLanguages: any = {};

    this.createAllowedLanguagesDictionary(brand, config, allowedLanguages);
    
    

    try {
      Object.keys(config.country).forEach((countryKey) => {
        const countryConfig = config.country[countryKey];
        const languages = Object.keys(countryConfig.language);
        // 1.b. fill object
        if (!allowedLanguages['country']) allowedLanguages['country'] = {};
        if (!allowedLanguages['country'][countryKey]) allowedLanguages['country'][countryKey] = {};
        allowedLanguages['country'][countryKey] = languages;
      });
    } catch (e) {}
    // 2. check language
    let isAllowed = false;
    try {
      isAllowed = allowedLanguages.country[country].includes(lang);
    } catch(e) {}
    try {
      isAllowed = allowedLanguages.brand[brand].country[country].includes(lang);
    } catch(e) {}
    return isAllowed;
  },


  /**
   * downloads and set up configurations based on query parameters
   */
  setupConfigurations: async function (startup?) {
    const queryParams = startup || oneUtils.utils.getQueryParams(window.location.href);

    const oldQueryParams = store.getters.getQueryParams;
    let isClientIdChanged = queryParams.client !== oldQueryParams.client;
    // const isCountryChanged = queryParams.country !== oldQueryParams.country;
    // const isLanguageChanged = queryParams.language !== oldQueryParams.language;
    // const isBrandChanged = queryParams.brand !== oldQueryParams.brand;
    //1. get base configuration if not downloaded yet
    const currentConfig = store.getters.getConfigurations.base;
    const isBaseConfigurationPresent = !oneUtils.utils.isObjEmpty(currentConfig);
    let baseConfigurationPromise;
    if (!isBaseConfigurationPresent) {
      baseConfigurationPromise = oneUtils.httpClient
        .getConfig(oneUtils.properties.BASE_CONFIG_FILE_NAME)
        .then((res) => {
          store.dispatch("setupBaseConfig", res);
          return res;
        })
        .catch(() => {
          // if no baseConfiguration throw an error
          console.debug("Unable to retrive base configuration...");
          // TODO: show error message (?)
          throw new Error("Unable to retrive base configuration...");
        });
    } else {
      //1.c if not changed, just use the current client configuration
      baseConfigurationPromise = currentConfig;
    }

    //2. check if client has changed
    let clientConfigurationPromise;
    let clientId = queryParams.client;

    // If no client / clientId was specified, load "gcdmone" config
    if(!clientId) {
      clientId = "gcdmone";
      isClientIdChanged = true;
    }

    if (isClientIdChanged) {
      //2.a if changed and present, try to download
      if (clientId) {
        clientConfigurationPromise = oneUtils.httpClient
          .getConfig(`client/${clientId}.json`)
          .then((res) => {
            store.dispatch("setupClientConfig", res);
            return res;
          })
          .catch(() => {
            console.debug(
              `Unable to retrive ${clientId} configuration...`
            );
            return undefined;
          });
      } else {
        //2.b if changed and not present, clear client configuration
        store.dispatch("setupClientConfig", {});
        clientConfigurationPromise = undefined;
      }
    } else {
      //2.c if not changed, just use the current client configuration
      const currentClientConfig = store.getters.getConfigurations.client;
      clientConfigurationPromise = !oneUtils.utils.isObjEmpty(currentClientConfig)
        ? currentClientConfig
        : undefined;
    }
    //3. wait for the configuration to be downloaded
    const baseConfiguration = await baseConfigurationPromise;
    const clientConfiguration = await clientConfigurationPromise;

    //4. validate params based on client allowed criteria
    const configurationsParams = await configUtils.evaluateParams(
      baseConfiguration,
      clientConfiguration,
      queryParams
    );
    //4.b. update clientId
    configurationsParams.client = clientId;

    let languageConfigurationPromise;
    let defaultLanguageConfigurationPromise;
    // check if already downloaded language
    if (!this.isLanguageAlreadyDownloaded(oneUtils.properties.DEFAULT_FALLBACK_LANGUAGE)) {
      defaultLanguageConfigurationPromise = oneUtils.httpClient
        .getConfig(`${oneUtils.properties.DEFAULT_FALLBACK_LANGUAGE}.json`)
        .then((res) => {
          store.dispatch("setupLanguages", res);
          return res;
        })
        .catch(() => {
          console.debug(
            `Unable to retrive ${oneUtils.properties.DEFAULT_FALLBACK_LANGUAGE} language...`
          );
          return undefined;
        });
    }

    // check if already downloaded language
    if (configurationsParams.language != oneUtils.properties.DEFAULT_FALLBACK_LANGUAGE && !this.isLanguageAlreadyDownloaded(configurationsParams.language)) {
      //5. download language specific translation file
      languageConfigurationPromise = oneUtils.httpClient
        .getConfig(`${configurationsParams.language}.json`)
        .then((res) => {
          store.dispatch("setupLanguages", res);
          return res;
        })
        .catch(() => {
          console.debug(`Unable to retrieve ${configurationsParams.language} language...`);
          return undefined;
        });
    }
    //6. wait for languages file to be downloaded
     await defaultLanguageConfigurationPromise;
    await languageConfigurationPromise;

    //7. merge configurations into one
    await store.dispatch("mergeCurrentConfig");

    const currentConfiguration = store.getters.getCurrentConfig;

    //8. apply changes on params
    store.dispatch("setupConfigParams", configurationsParams);

    return currentConfiguration;
  },



  /**
   * Checks if the language provided is already present in the store
   * @param language
   */
  isLanguageAlreadyDownloaded(language: string): boolean {
    const configurations = store.getters.getConfigurations;
    const isAlreadyDownloaded = !!configurations.base.translation
      && !!configurations.base.translation.language
      && !!configurations.base.translation.language[language];
    return isAlreadyDownloaded;
  },

  replacePlaceholders(text: string): string {
    if (!text) {
      return "";
    }
    // brand - start
    if (text.includes("${brand}")) {
      // const brandLabel = configUtils.getTranslation(
      //   configurations,
      //   configurationParams,
      //   "_brand_label"
      // ) || "";
      const brandLabel =store.getters.configure(
        "_brand_label"
      ) || "";
      text = text.replace(/\${brand}/g, brandLabel);
    }

    if (text.includes("${brand_for_brand_id}")) {
      // const brandLabel = configUtils.getTranslation(
      //   configurations,
      //   configurationParams,
      //   "_brand_label"
      // ) || "";
      let brandForBrandIDLabel =store.getters.configure(
        "_brand_for_brand_id_label"
      ) || store.getters.configure(
        "_brand_label"
      ) || "";

      text = text.replace(/\${brand_for_brand_id}/g, brandForBrandIDLabel);
    }
    // brand - end
    return text;
  },

  translate(configurations, configurationParams, key): string {
    let translation = configUtils.getTranslation(
      configurations,
      configurationParams,
      key
    );
    translation = configUtils.replacePlaceholders(
      translation    );
    return translation;
  },

  getTranslation(configurations, configurationParams, key): string {
    const brand = configurationParams.brand;
    const lang = configurationParams.language;
    const country = configurationParams.country;
    const translation = configurations.base.translation;
    const clientTranslation = configurations.current.translation;

    // only for debug
    if (lang === "debug") {
      return key;
    }

    // translation not loaded yet!
    if (!translation || oneUtils.utils.isObjEmpty(translation)) {
      return "";
    }

    // try to find key inside client configuration
    try {
      return oneUtils.utils.returnIfExists(
        clientTranslation.brand[brand].language[lang].country[country][key]
      );
    } catch (e) {}
    try {
      return oneUtils.utils.returnIfExists(
        clientTranslation.brand[brand].language[lang][key]
      );
    } catch (e) {}
    try {
      return oneUtils.utils.returnIfExists(
        clientTranslation.language[lang].country[country][key]
      );
    } catch (e) {}
    try {
      return oneUtils.utils.returnIfExists(clientTranslation.language[lang][key]);
    } catch (e) {}

    // try to find key inside base configuration
    try {
      return oneUtils.utils.returnIfExists(
        translation.brand[brand].language[lang].country[country][key]
      );
    } catch (e) {}
    try {
      return oneUtils.utils.returnIfExists(translation.brand[brand].language[lang][key]);
    } catch (e) {}
    try {
      return oneUtils.utils.returnIfExists(
        translation.language[lang].country[country][key]
      );
    } catch (e) {}
    try {
      return oneUtils.utils.returnIfExists(translation.language[lang][key]);
    } catch (e) {}

    // fallback
    const langFallback = oneUtils.properties.DEFAULT_FALLBACK_LANGUAGE;
    try {
      return oneUtils.utils.returnIfExists(
        translation.brand[brand].language[langFallback].country[country][key]
      );
    } catch (e) {}
    try {
      return oneUtils.utils.returnIfExists(
        translation.brand[brand].language[langFallback][key]
      );
    } catch (e) {}
    try {
      return oneUtils.utils.returnIfExists(
        translation.language[langFallback].country[country][key]
      );
    } catch (e) {}
    
    return translation.language[langFallback] ? translation.language[langFallback][key] : key;
  },

  configure(configurations, configurationParams, key): any {
    try {
      return this.configureMerge(configurations, configurationParams, key);
    } catch (e) {
      return this.configureReplace(configurations, configurationParams, key);
    }
  },

  getKeyFromBaseConfig : (confToBeMerged, config, country, lang, brand, key)=>{
    try {
      confToBeMerged.push(oneUtils.utils.returnIfExists(config.brand[brand][key]));
    } catch (e) {}
    try {
      confToBeMerged.push(oneUtils.utils.returnIfExists(config.country[country][key]));
    } catch (e) {}
    try {
      confToBeMerged.push(oneUtils.utils.returnIfExists(config.country[country].language[lang][key]));
    } catch (e) {}
    try {
      confToBeMerged.push(oneUtils.utils.returnIfExists(config.brand[brand].country[country][key]));
    } catch (e) {}
    try {
      confToBeMerged.push(oneUtils.utils.returnIfExists(config.brand[brand].country[country].language[lang][key]));
    } catch (e) {}

    return confToBeMerged;
  },

  configureMerge(configurations, configurationParams, key): any {
    const brand = configurationParams.brand;
    const lang = configurationParams.language;
    const country = configurationParams.country;
    const config = configurations.base.config;
    const clientConfig = configurations.client.config;

    // config not loaded yet!
    if (!config || oneUtils.utils.isObjEmpty(config)) {
      return undefined;
    }

    let confToBeMerged: any[] = [];

    // fallback
    try {
      confToBeMerged.push(oneUtils.utils.returnIfExists(config[key]));
    } catch (e) {}

    // trying to find key inside base configuration
    confToBeMerged = this.getKeyFromBaseConfig(confToBeMerged, config, country, lang, brand, key);
    
    // trying to find key inside client configuration
    try {
      confToBeMerged.push(oneUtils.utils.returnIfExists(clientConfig[key]));
    } catch (e) {}
    try {
      confToBeMerged.push(oneUtils.utils.returnIfExists(clientConfig.brand[brand][key]));
    } catch (e) {}
    try {
      confToBeMerged.push(oneUtils.utils.returnIfExists(clientConfig.country[country][key]));
    } catch (e) {}
    try {
      confToBeMerged.push(oneUtils.utils.returnIfExists(clientConfig.country[country].language[lang][key]));
    } catch (e) {}
    try {
      confToBeMerged.push(oneUtils.utils.returnIfExists(clientConfig.brand[brand].country[country][key]));
    } catch (e) {}
    try {
      confToBeMerged.push(oneUtils.utils.returnIfExists(clientConfig.brand[brand].country[country].language[lang][key]));
    } catch (e) {}

    const areAllObjects = confToBeMerged.every(a => typeof a === 'object' || a === undefined);
    if (confToBeMerged.length === 0 || !areAllObjects) {
      throw new Error('items could not be merged');
    }
    return deepmerge.all(confToBeMerged);
  },

  /**
   * @param configurations
   * @param configurationParams
   * @param key
   */
  configureReplace(configurations, configurationParams, key): any {
    const brand = configurationParams.brand;
    const lang = configurationParams.language;
    const country = configurationParams.country;
    const config = configurations.base.config;
    const clientConfig = configurations.client.config;

    // config not loaded yet!
    if (!config || oneUtils.utils.isObjEmpty(config)) {
      return undefined;
    }

    // try to find key inside client configuration
    try {
      return oneUtils.utils.returnIfExists(
        clientConfig.brand[brand].country[country].language[lang][key]
      );
    } catch (e) {}
    try {
      return oneUtils.utils.returnIfExists(
        clientConfig.brand[brand].country[country][key]
      );
    } catch (e) {}
    try {
      return oneUtils.utils.returnIfExists(
        clientConfig.country[country].language[lang][key]
      );
    } catch (e) {}
    try {
      return oneUtils.utils.returnIfExists(clientConfig.country[country][key]);
    } catch (e) {}
    try {
      return oneUtils.utils.returnIfExists(clientConfig.brand[brand][key]);
    } catch (e) {}
    try {
      return oneUtils.utils.returnIfExists(clientConfig[key]);
    } catch (e) {}

    // try to find key inside base configuration
    try {
      return oneUtils.utils.returnIfExists(
        config.brand[brand].country[country].language[lang][key]
      );
    } catch (e) {}
    try {
      return oneUtils.utils.returnIfExists(config.brand[brand].country[country][key]);
    } catch (e) {}
    try {
      return oneUtils.utils.returnIfExists(config.country[country].language[lang][key]);
    } catch (e) {}
    try {
      return oneUtils.utils.returnIfExists(config.country[country][key]);
    } catch (e) {}
    try {
      return oneUtils.utils.returnIfExists(config.brand[brand][key]);
    } catch (e) {}

    // fallback
    try {
      return oneUtils.utils.returnIfExists(config[key]);
    } catch (e) {}
    return undefined;
  },

};

export default configUtils;
